/**
 * The flag in `enabledFeatureFlags` with which a portal switches e-learning (the packages and, later, digital learning
 * with its player) over from learning-academy to the leerplatform. The academy refuses package management once it is on.
 */
export const ELEARNING_IN_LEERPLATFORM = 'elearningInLeerplatform';

/**
 * The base url of the package-management endpoints (`api/packages`, `api/packages/{id}` and `api/activatePackageInfo`):
 * the leerplatform once the portal has switched e-learning over — the academy sends its package pages there and refuses
 * its own management writes — and the academy until then. The paths and shapes are the same on both. Activating,
 * deactivating, resetting, deleting and their `HasInstances` check follow the same flag: with the flag on the academy
 * refuses them, and the leerplatform serves the management writes with the Catalog API (backlog 3.8, packages).
 */
export const elearningApiUrl = (settings) =>
    settings.enabledFeatureFlags?.[ELEARNING_IN_LEERPLATFORM]
        ? settings.apiUrl
        : settings.portalApiUrl;
